// 数値関連のユーティリティ関数

// 数値の範囲を指定して、指定した数の等間隔の数値を生成する関数
// start: 開始値
// end: 終了値
// num: 生成する数値の数
// 例: linspace(0, 1, 5) => [0, 0.25, 0.5, 0.75, 1]
export const linspace = (start, end, num) => {
  const step = (end - start) / (num - 1);
  return Array.from({ length: num }, (_, i) => start + i * step);
}